export const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case 'en stock':
      return 'bg-siby-100 text-siby-600 border-siby-200';
    case 'stock bas':
      return 'bg-orange-100 text-orange-600 border-orange-200';
    case 'rupture':
      return 'bg-red-100 text-red-600 border-red-200';
    default:
      return 'bg-gray-100 text-gray-600 border-gray-200';
  }
};